/* template */
<template minapp="mpx" xlang="wxml"><div class="radio-icon__container"><es-icon name="circle" :size="(size)" color="#D4D3D3" v-if="(!checked)"/><es-icon name="dot-circle" :size="(size)" color="#1473ff" v-else/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m17a49170"}'>
  .radio-icon__container
    display inline-block
    display flex
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m17a49170"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex17a49170%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex17a49170%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m17a49170"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index17a49170/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
